var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "layout",
    [
      _c("layer-details", {
        attrs: { moduleId: _vm.moduleCode, isLayer: _vm.isLayer },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }